const index = {
    title: 'DataMapper.ai | Automatically finds and sorts your company’s documents',
    metaTag: 'An AI powered document assistant that automatically identifies and sorts \
    your company’s most important documents across Dropbox, Gdrive, mail and local drives. \
    It eliminates time spent on saving, organizing, and finding documents and removes \
    the risk of losing them.'
}

const security = {
    title: 'Security - How We Secure and Protect Your Data | DataMapper',
    metaTag: 'We protect your data by using both technical and administrative security measures. \
    We use the  TLS protocol ensuring your data is kept safe and we use Amazon \
    Web Services or Microsoft Azure who uses state-of-the-art \
    access control and operates server facilities that are physically guarded.'
}

const signup = {
    title: 'Sign up - Be an Early Beta Tester | DataMapper',
    metaTag: 'Be one of the first to try DataMapper. Stop wasting time finding and\
    organizing your documents. DataMapper does it for you – automatically.'
}

const policy = {
    title: 'Privacy Policy - Data Responsibility and Cookies | DataMapper',
    metaTag: 'We take your data protection seriously. Click to read how\
    we handle personal data and read our policy.'
}

const faqs = {
    title: 'FAQs | DataMapper',
    metaTag: 'Frequently Asked Questions - Security, structure and file placement, document control and more'
}

const team = {
    title: 'Meet our Team | DataMapper',
    metaTag: 'Meet the team that takes document handling from the 90s into 2018'
}

const jobs = {
    title: 'Jobs | DataMapper',
    metaTag: 'Open vacancies – Come join our team!\
    We always encourage you to submit an unsolicited application.\
    We live in the heart of Copenhagen and are always on the lookout for more friends. '
}

const about = {
    title: 'About | DataMapper',
    metaTag: 'We want to make every document easy accessible. \
    Be able to extract business intelligence from the documents and make \
    sure companies run their business better with no loss of knowledge.'
}

module.exports = {
    '/': index,
    '/security': security,
    '/team': team,
    '/faqs': faqs,
    '/about': about,
    '/policy': policy,
    '/jobs': jobs,
    '/about': about,
    '/signup': signup
}



// WEBPACK FOOTER //
// ./config/metaPageInfo.js